<template>
  <div>
    <b-breadcrumb :items="breadCrumbs" />

    <div class="row mb-3">
      <div class="col-12">
        <b-btn
          variant="primary"
          size="md"
          class="float-right"
          :to="'/testing/requests/add'"
        >Add Testing Request
        </b-btn
        >
      </div>
    </div>

    <b-row class="mt-3">
      <b-col md="12">
        <b-table
          :items="testingRequests"
          :fields="fields"
          v-if="testingRequests"
        >
          <template slot="cell(stock)" slot-scope="row">
            <ul>
              <li :key="index" v-for="(item, index) in row.item.stock">
                {{
                  item.quantity + " X " + item.model + " (" + item.name + ")"
                }}
              </li>
            </ul>
          </template>
          <template slot="cell(samples)" slot-scope="row">
            <ul>
              <li :key="index" v-for="(item, index) in row.item.sample">
                {{ item.supplier_code }}, {{ item.ingredient_name }},
                {{ item.supplier_batch_number }},
                {{ item.quantity + "(" + item.quantity_type + ")" }}
              </li>
            </ul>
          </template>
          <template slot="cell(actions)" slot-scope="row">
            <div style="width: 400px">
              <b-button
                size="sm"
                variant="warning"
                class="ml-2"
                :to="
                  '/testing/requests/' + row.item.testing_request_id + '/edit/'
                "
              >Edit
              </b-button
              >
              <b-button
                size="sm"
                variant="primary"
                class="ml-2"
                :to="
                  '/testing/requests/' +
                  row.item.testing_request_id +
                  '/sample/'
                "
              >Samples
              </b-button
              >
              <b-button
                size="sm"
                variant="danger"
                class="ml-2"
                @click="deleteConfirm(row.item.testing_request_id)"
              >Delete
              </b-button
              >

              <b-button
                size="sm"
                variant="warning"
                class="ml-2"
                @click="submissionForm(row.item.testing_request_id)"
              >Submission Form
              </b-button
              >
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row v-if="!testingRequests || testingRequests.length == 0">
      <b-col md="6" class="my-1 offset-md-3">
        <b-alert show variant="success">No testing requests yet!</b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "testing-requests",
  components: {},
  data() {
    return {
      testingRequests: null,
      fields: [
        { key: "testing_request_id", label: "#", sortable: true },
        { key: "shipping_date", label: "Shipping Date" },
        { key: "tracking_number", label: "Tracking Number" },
        { key: "comments", label: "Comments" },
        { key: "samples", label: "Samples" },
        { key: "actions", label: "" },
      ],
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Testing Requests", active: true },
      ],
    };
  },
  mounted: function () {
    this.getTestingRequests();
  },
  methods: {
    getTestingRequests: function () {
      let loader = this.$loading.show();
      this.$http.get(this.APIURL + this.BRAND + "/testing/requests").then(
        (response) => {
          this.testingRequests = response.data.testingRequests;

          loader.hide();
        },
        (error) => {
          loader.hide();
          console.log(error);
        }
      );
    },
    deleteConfirm(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You want to delete testing requests: " + id,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if ( result.value ) {
          this.deleteTestingRequest(id);
        }
      });
    },
    deleteTestingRequest(id) {
      let loader = this.$loading.show();
      this.$http
      .delete(this.APIURL + this.BRAND + "/testing/requests/" + id)
      .then(
        () => {
          this.$swal({
            title: "Success!",
            showConfirmButton: false,
            timer: 1000,
            html: "Testing request deleted successfully!",
            type: "success",
            onClose: () => {
              loader.hide();
              this.getTestingRequests();
            },
          });
        },
        (error) => {
          console.log(error);
        }
      );
    },
    submissionForm(id) {
      let url =
        this.APIURL + this.BRAND + "/testing/requests/submission/form/" + id;
      window.open(url, "_blank");
    },
  },
};
</script>
